/** Pending referral invite code during signup flow (sessionStorage). */

export const SIGNUP_REFERRAL_STORAGE_KEY = "signup_referral_invite_code";

export function getSignupReferralCode(): string {
  if (typeof sessionStorage === "undefined") return "";
  try {
    return String(sessionStorage.getItem(SIGNUP_REFERRAL_STORAGE_KEY) ?? "").trim();
  } catch {
    return "";
  }
}

export function setSignupReferralCode(code: string): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    const t = code.trim().toUpperCase();
    if (t.length < 3) {
      sessionStorage.removeItem(SIGNUP_REFERRAL_STORAGE_KEY);
    } else {
      sessionStorage.setItem(SIGNUP_REFERRAL_STORAGE_KEY, t);
    }
  } catch {
    // ignore
  }
}

export function clearSignupReferralCode(): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(SIGNUP_REFERRAL_STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Same-tab listeners (e.g. ReferralInviteCard badge). */
export function notifySignupReferralStorageChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event("signup-referral-storage"));
}
